export default __webpack_public_path__ + "static/media/(3)-Dupla.5f113f20.jpg";